import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useNewProfileDialog } from '@/contexts/new-profile-dialog-context';
import { usePianoProfileState } from '@/hooks/store/use-piano-profile-store';
import { useTranslation } from '@/hooks/use-translation';

/**
 * The hatched strip that says the instrument on screen is not the reader's.
 *
 * Full width under the header rather than a card inside the page: it is a
 * property of the whole session, not of the page being read.
 */
export const DemoProfileBanner = () => {
  const $ = _c(20);
  const {
    t
  } = useTranslation();
  const {
    isDemoProfile
  } = usePianoProfileState();
  const {
    openNewProfileDialog
  } = useNewProfileDialog();
  let t0;
  if ($[0] !== openNewProfileDialog) {
    t0 = () => {
      openNewProfileDialog();
    };
    $[0] = openNewProfileDialog;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreateNewProfile = t0;
  if (!isDemoProfile) {
    return null;
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("Demo piano");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <span className="font-serif text-[17px] italic text-ptl-brass">{t1}</span>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("You are currently viewing an example piano, so you can explore every feature freely.");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <span className="flex-[1_1_320px] text-muted-foreground">{t3}</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("Create a new piano profile");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span aria-hidden="true">→</span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onCreateNewProfile || $[14] !== t5) {
    t7 = <button type="button" onClick={onCreateNewProfile} className="cursor-pointer font-semibold text-ptl-brass transition-colors hover:text-foreground">{t5} {t6}</button>;
    $[13] = onCreateNewProfile;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t4 || $[18] !== t7) {
    t8 = <div data-slot="demo-banner" className="ptl-demo-banner flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-border px-10 py-2.5 text-[13.5px] max-md:px-4 print:hidden">{t2}{t4}{t7}</div>;
    $[16] = t2;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};